/**
 * Labstep
 *
 * @module prosemirror/components/Menu/Commands/Menu/Item
 * @desc A menu item for elements
 */

import { Card } from 'labstep-web/core/Card/Card';
import { Flex } from 'labstep-web/core/Flex';
import { Header } from 'labstep-web/core/Header';
import { Icon } from 'labstep-web/core/Icon';
import { PremiumFeatureLockIcon } from 'labstep-web/core/PremiumFeature/LockIcon';
import { MenuCommandsMenuItemLabel } from 'labstep-web/prosemirror/components/Menu/Commands/Menu/Item/Label';
import type React from 'react';
import { Image, Menu } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { IMenuCommandsMenuItemProps } from './types';

export const MenuCommandsMenuItem: React.FC<
  IMenuCommandsMenuItemProps
> = ({
  onClick,
  header,
  icon,
  image,
  description,
  active,
  disabled,
  label,
  premiumFeature,
}) => (
  <Menu.Item
    data-testid="menu_item"
    active={active}
    disabled={disabled}
    onClick={onClick}
    data-public
  >
    <Flex vAlignContent="center">
      <Card className={styles.iconCard}>
        {icon && <Icon name={icon} className={styles.icon} />}
        {image && (
          <Image src={image} className={styles.icon} data-public />
        )}
      </Card>
      <div className={styles.textContainer}>
        <Header className={styles.header} size="mini" noMargin>
          {header}
          {label && <MenuCommandsMenuItemLabel label={label} />}
          {premiumFeature && (
            <PremiumFeatureLockIcon premiumFeature={premiumFeature} />
          )}
        </Header>
        <p data-public>{description}</p>
      </div>
    </Flex>
  </Menu.Item>
);
